export function accordion() {
    var accordion = $(".accordion");
    var accordionItem = accordion.find(".accordion-item");
    var accordionItemTitle = accordionItem.find(".title");

    accordionItemTitle.on("click", function () {

        let $parent = $(this).closest(".accordion-item");
        let items = $parent.siblings();
        if (!$parent.hasClass("active")) {
            items.removeClass("active").find(".description").slideUp();
        }
        $parent.toggleClass("active").find(".description").slideToggle();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js